import { FC, useEffect, useState } from "react";
import {
  useAlertStore,
  usePopupStore,
  useThemeStore,
  useUserStore,
} from "../../../stores";
import { Column, Row } from "../../../components/containers";
import {
  AlignItems,
  JustifyContent,
  Wrap,
} from "../../../components/containers/types";
import { PopupClose } from "../../../popup";
import { Heading } from "../../../components/typography";
import { TagInput, TextInput } from "../../../components/inputs";
import { Button } from "../../../components/buttons";
import { CustomerApi } from "../../../api";

const CustomerAddPopup: FC = () => {
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const theme = useThemeStore((s) => s.theme);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 816,
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [fullname, setFullname] = useState<string>("");
  const [nationalCode, setNationalCode] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [tags, setTags] = useState<Array<string>>([]);

  const [loading, setLoading] = useState<boolean>(false);
  const hasUserAccess = useUserStore((s) => s.hasUserAccess);

  const onAdd = (): void => {
    if (!hasUserAccess(["AddEditCustomer"]))
      return pushAlert("دسترسی غیر مجاز", "error");
    if (!fullname || !nationalCode || !phone || !address)
      return pushAlert(
        "لطفا مطمئن شوید که فیلدها به درستی پر شده اند",
        "error"
      );
    setLoading(true);
    CustomerApi.addCustomer(fullname, nationalCode, phone, address, tags)
      .then(() => {
        setPopupBody(null);
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Start}
      style={{ marginBottom: "1rem", position: "relative" }}
      gap={20}
    >
      <PopupClose />
      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        ثبت مشتری جدید
      </Heading>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="نام و نام خانوادگی"
          value={fullname}
          setValue={setFullname}
        />
        <TextInput
          style={{ maxWidth: 300 }}
          label="کد ملی"
          value={nationalCode}
          setValue={setNationalCode}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          style={{ maxWidth: 300 }}
          label="تلفن همراه"
          value={phone}
          setValue={setPhone}
        />
        <TagInput
          label="تگ"
          value={tags}
          setValue={setTags}
          style={{ maxWidth: 300 }}
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.Between}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <TextInput
          label="آدرس"
          value={address}
          setValue={setAddress}
          className="customer-activity-popup-inp"
        />
      </Row>
      <Row
        style={{ width: "90%" }}
        justifyContent={JustifyContent.End}
        gap={20}
        flexWrap={Wrap.Wrap}
        className="customer-activity-popup-row"
      >
        <Button
          className="customer-activity-popup-btn"
          background={theme.primary}
          color={theme.textOnprimary}
          loading={loading}
          onClick={onAdd}
        >
          ثبت
        </Button>
      </Row>
    </Column>
  );
};

export default CustomerAddPopup;
